/* Publish by EComposer at 2026-10-13 12:58:53*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wdkp73qlp9"]=  window.__ectimmers["ecom-wdkp73qlp9"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-wdkp73qlp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wdkp73qlp9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbpw1he8r3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbpw1he8r3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-thtxdkqga2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thtxdkqga2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4t2kp6eant2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4t2kp6eant2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o39hq1086bg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o39hq1086bg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7pnn8z9q2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7pnn8z9q2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7avowkd0tmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7avowkd0tmo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xl5kaa1cs9s"]=  window.__ectimmers["ecom-xl5kaa1cs9s"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-xl5kaa1cs9s"]["r3g96n0tx"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xl5kaa1cs9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xl5kaa1cs9s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zc0hpw03uxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zc0hpw03uxq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkzywuddrcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkzywuddrcg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hdkl6dvz1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hdkl6dvz1z', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7g37f2bp0l9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7g37f2bp0l9', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8yb33m926qw"]=  window.__ectimmers["ecom-8yb33m926qw"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-8yb33m926qw"]["v93eatrwt"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-8yb33m926qw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yb33m926qw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-68c9ycs5br2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-68c9ycs5br2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1n1dl0t8ist').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1n1dl0t8ist', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eqy1rlzo484').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eqy1rlzo484', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jhf920eukyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jhf920eukyo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4si57wzfus').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4si57wzfus', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jo9vil14ild').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jo9vil14ild', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lk59ubhaik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lk59ubhaik', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}